import { render, staticRenderFns } from "./SpouseInfoWidget.vue?vue&type=template&id=54cfae79&scoped=true"
import script from "./SpouseInfoWidget.vue?vue&type=script&lang=js"
export * from "./SpouseInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./SpouseInfoWidget.vue?vue&type=style&index=0&id=54cfae79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cfae79",
  null
  
)

/* custom blocks */
import block0 from "./SpouseInfoWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports